<template>
	<footer class="site-footer">
		<section class="main-footer">
			<div class="container">
				<div class="main-footer-wrapper flex flex-col-reverse items-center justify-between md:flex-row">
					<ul class="list-unstyled copy-right mb-0 flex w-full flex-row items-center justify-between lg:w-auto">
						<li class="copy-right-item">© {{ year }} <a href="/">directori.com</a> All rights reserved.</li>
						<li class="copy-right-item copy-right-item-divider"></li>
						<li class="copy-right-item">
							<a href="javascript:void(0);">Privacy & Terms</a>
						</li>
					</ul>
					<ul class="list-unstyled social-menu mb-0 hidden flex-row items-center justify-center lg:flex">
						<li class="social-menu-item">
							<a href="javascript:void(0);">
								<FacebookIcon />
							</a>
						</li>
						<!-- Each item -->
						<li class="social-menu-item">
							<a href="javascript:void(0);">
								<TwitterXIcon />
							</a>
						</li>
						<!-- Each item -->
						<li class="social-menu-item">
							<a href="javascript:void(0);">
								<LinkedinIcon />
							</a>
						</li>
						<!-- Each item -->
					</ul>
				</div>
			</div>
		</section>
	</footer>
</template>
<script setup>
import FacebookIcon from "./Svg/FacebookIcon.vue";
import LinkedinIcon from "./Svg/LinkedinIcon.vue";
import TwitterXIcon from "./Svg/TwitterXIcon.vue";

const year = new Date().getFullYear();
</script>
